
import { MENU_BOOK_SEARCH } from "@/constants/MixpanelEvents.js";
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  props: {
    classProp: {
      default: "search-field-1 border-1"
    }
  },
  data() {
    return {
      isFocused: false,
      search: "",
      result: []
    };
  },
  computed: {
    ...mapState("menu", ["menuItems", "searchBy", "isSearchMode"])
  },
  mounted() {
    if (this.searchBy) {
      this.search = this.searchBy;
      this.$refs?.menuHeaderSearchField?.focus();
    }
  },
  watch: {
    search(val) {
      this.SET_SEARCH_BY(val);
      if (val) {
        this.mixPanelTrackEvent(MENU_BOOK_SEARCH, { searchBy: val });
      }
      // if (val && typeof val === "object") {
      //   this.navigateToDetailPage(val.id);
      // } else {
      //   this.result = val
      //     ? this.menuItems.filter(order => {
      //         return (
      //           String(order.item_name).indexOf(val) >= 0 ||
      //           String(order.item_long_description).indexOf(val) >= 0
      //         );
      //       })
      //     : [];
      // }
    }
  },
  methods: {
    ...mapMutations("menu", ["SET_SEARCH_BY", "SET_IS_SEARCH_MODE"]),
    navigateToDetailPage(id) {
      this.$router.push(`/menu/${id}/item`);
    },
    handleClear() {
      this.search = "";
      this.SET_SEARCH_BY("");
      this.SET_IS_SEARCH_MODE(false);
      this.$refs.menuHeaderSearchField.blur();
    }
  }
};
